// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /gif/search.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeGifSearchBody,
  typeGifSearchOutput200,
} from "../../sdk/gif/postGifSearch";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildGifSearchQueryKey(payload: typeGifSearchBody): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`query:${JSON.stringify(payload.query)}`);
  if (typeof payload.cursor !== "undefined") {
    queryKeySegments.push(`cursor:${JSON.stringify(payload.cursor)}`);
  }
  return ["post:gif:gifSearch", "svc:messaging-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeGifSearchOutput200,
    unknown,
    typeGifSearchOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useGifSearch(
  payload: typeGifSearchBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildGifSearchQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postGifSearch(payload),
    ...resolvedOptions,
  });
}
